// Source: HeroSection. Values include intentional inline spacing.
import { tpchCopy } from '@/data/hardcharger-launch';

const tpchEn = tpchCopy('en');
const tpchPt = tpchCopy('pt-BR');
const en = {
  "s4": "New: Hardcharger™, GizmoSQL’s successor, built for DuckDB 2.0",
  "titleStart": "Meet Hardcharger™: fast, secure, ",
  "titleHighlight": "remote DuckDB",
  "subtitle": "Hardcharger is our open-source server for DuckDB 2.0: SQL over plain HTTP with Apache Arrow results, access control built in, a web UI in the binary, and every feature included. GizmoData Cloud is the best way to run it: managed, in one click, on AWS, Google Cloud and Azure.",
  "point1": `A 1 TB workload derived from TPC-H in ${tpchEn.hcSeconds} seconds on one machine, about ${tpchEn.hcCostRounded} of AWS on-demand compute per run${tpchEn.qualifier}`,
  "point2Start": "GizmoData Cloud plans from ",
  "point2End": "/month, and the fee comes back in full as compute credit",
  "point3": "Users, roles, row policies, SSO and mTLS in the free build: no license keys",
  "point4": "Apache-2.0 open source, with drivers for Python, Go, Java and JavaScript",
  "s11": "Run it on GizmoData Cloud",
  "s12": "Explore Hardcharger",
  "launchOfferStart": "Launch offer: ",
  "launchOfferEnd": " of free credit, applied automatically when you sign up through the button above. No credit card needed. ",
  "s16": "Rather self-host? ",
  "s17": "Install Hardcharger in one line",
  "s18": "From the team behind GizmoSQL: 100K+ Docker pulls · In production at Summation & Randoli · Featured on Product Hunt",
  "s20": "Hardcharger™: the charging bull and wordmark"
};
const pt: typeof en = {
  "s4": "Novidade: Hardcharger™, o sucessor do GizmoSQL, criado para o DuckDB 2.0",
  "titleStart": "Conheça o Hardcharger™: ",
  "titleHighlight": "DuckDB remoto, rápido e seguro",
  "subtitle": "O Hardcharger é o nosso servidor de código aberto para o DuckDB 2.0: SQL sobre HTTP simples com resultados em Apache Arrow, controle de acesso integrado, uma interface web no próprio binário e todos os recursos incluídos. O GizmoData Cloud é a melhor forma de executá-lo: gerenciado, com um clique, na AWS, no Google Cloud e no Azure.",
  "point1": `Uma carga de trabalho de 1 TB derivada do TPC-H em ${tpchPt.hcSeconds} segundos em uma única máquina, cerca de ${tpchPt.hcCostRounded} de computação sob demanda na AWS por execução${tpchPt.qualifier}`,
  "point2Start": "Planos do GizmoData Cloud a partir de ",
  "point2End": "/mês, e a mensalidade volta integralmente como crédito de computação",
  "point3": "Usuários, papéis, políticas de linha, SSO e mTLS na versão gratuita: sem chaves de licença",
  "point4": "Código aberto Apache-2.0, com drivers para Python, Go, Java e JavaScript",
  "s11": "Execute no GizmoData Cloud",
  "s12": "Conheça o Hardcharger",
  "launchOfferStart": "Oferta de lançamento: ",
  "launchOfferEnd": " de crédito grátis, aplicado automaticamente ao se cadastrar pelo botão acima. Sem cartão de crédito. ",
  "s16": "Prefere hospedar por conta própria? ",
  "s17": "Instale o Hardcharger com uma linha",
  "s18": "Da equipe por trás do GizmoSQL: mais de 100 mil pulls no Docker · Em produção na Summation e na Randoli · Destaque no Product Hunt",
  "s20": "Hardcharger™: o touro em disparada e o logotipo"
};
export default { en, 'pt-BR': pt };
